/*
 * Description: Display Note Web Component
 * Purpose: Displays an informational note using Bootstrap alert styling
 * Author: Nuvemx
 * Created: 2026
 *
 * Features:
 * - Bootstrap alert-info styling with Boxicons icon
 * - Optional title attribute
 * - Slot-based content
 *
 * Usage:
 * <display-note title="Note:">Some important information.</display-note>
 * <display-note>Information without title.</display-note>
 *
 * Attributes:
 * - title: String - Optional bold heading text
 *
 */

import './display_note.css';

class display_note extends HTMLElement {
    connectedCallback() {
        // Skip if already rendered
        if (this.dataset.rendered) return;

        const title = this.getAttribute('title');
        const content = this.innerHTML.trim();
        
        this.innerHTML = `
            <div class="alert note-alert d-flex" role="alert">
                <i class="bx bx-info-circle note-icon fs-5"></i>
                <div class="note-body">
                    ${title ? `<div class="note-title"><strong>${title}</strong></div>` : ''}
                    <div class="note-content">${content || 'Empty'}</div>
                </div>
            </div>`;

        // Mark the component as rendered
        this.dataset.rendered = "true";
    }
}

export { display_note };

